// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3cOD_","noInteraction":"EventWrapper_noInteraction__10KzC","pointerPassthrough":"EventWrapper_pointerPassthrough__1kZX2"};